// utils
import { isMobile } from '../utils/isMobile';

const $ = jQuery;
const $header = $('.header');

// start with rewriting this to vanillaJS
const { body } = document;
const header = document.querySelector('header.header');
const animationDuration = 200;
const headerScrollThreshold = 300;
const headerScrollingClass = 'header--on-scroll';

// helpers
const slideFadeToggle = ($selector) => {
  const $selectorDisplay = $selector.css('display');

  if ($selectorDisplay === 'none') {
    // open
    $selector
      .stop(true, true)
      .fadeIn({ duration: animationDuration, queue: false })
      .css('display', 'none')
      .slideDown({
        duration: animationDuration,
        start: () => {
          $selector.css({
            display: 'flex',
          });
        },
      });
    $selector.parent().addClass('main-menu__item--open');
  } else {
    // close
    $selector
      .stop(true, true)
      .fadeOut({ duration: animationDuration, queue: false })
      .slideUp({
        duration: animationDuration,
        complete: () => {
          $selector
            .next('.main-menu__items')
            .removeClass('main-menu__items--opposite-direction');
        },
      });
    $selector.parent().removeClass('main-menu__item--open');
  }
};

const closeAllSubmenus = () => {
  $header.removeClass('header--menu-open');
  const $link = $('.main-menu__item--open .main-menu__link');
  $link.next('.main-menu__items').fadeOut({
    duration: animationDuration,
    complete: () => {
      $link
        .next('.main-menu__items')
        .removeClass('main-menu__items--opposite-direction');
    },
  });

  $link.parent().removeClass('main-menu__item--open');
  $('body').unbind('click');
};

const hasEnoughSpaceToOpen = (el) => {
  return el.offset().left + 600 > window.outerWidth;
};

const $menuTrigger = $(
  '.main-menu__open-trigger, .main-menu__close-trigger, .main-menu__backdrop',
);

$menuTrigger.click((e) => {
  e.preventDefault();
  const $mainMenu = $('.main-menu');
  $mainMenu.toggleClass('main-menu--open');
  $header.toggleClass('header--menu-open');
  if ($mainMenu.hasClass('main-menu--open')) {
    if (!$header.hasClass('header--fixed')) {
      $(window).scrollTop(0);
    }
    $('body').css('overflowY', 'hidden');
  } else {
    $('body').css('overflowY', 'auto');
  }
});

$('.main-menu__link--has-children').click((e) => {
  e.preventDefault();
  const $this = $(e.target);
  const $secondLevelMenu = $this.next('.main-menu__items');

  if (isMobile()) {
    slideFadeToggle($secondLevelMenu);
  } else {
    if ($secondLevelMenu.css('display') === 'flex') {
      closeAllSubmenus();
      return;
    }
    closeAllSubmenus();

    $secondLevelMenu.fadeToggle({
      duration: animationDuration,
      start: () => {
        $('body').unbind('click');
        $secondLevelMenu.unbind('click');
        $secondLevelMenu.css('display', 'flex');
        $secondLevelMenu.parent().addClass('main-menu__item--open');
        $header.addClass('header--menu-open');
        if (hasEnoughSpaceToOpen($this)) {
          $this
            .next('.main-menu__items')
            .addClass('main-menu__items--opposite-direction');
        }
      },
      done: (cb) => {
        const elDisplay = $(cb.elem).css('display');
        if (elDisplay === 'flex') {
          $('body').bind('click', closeAllSubmenus);
          $secondLevelMenu.bind('click', (event) => {
            event.stopPropagation();
          });
        }
      },
    });

    // add value for max height to allow scrolling
    const overviewItem = $('.main-menu__items--level-1 li:first-child');
    const maxHeight = $header.innerHeight() + overviewItem.innerHeight();
    $header[0].style.setProperty('--max-menu-height', `${maxHeight}px`);
  }
});

// on scroll event
window.addEventListener('scroll', () => {
  // @todo clean this up so you don't cringe every time you this this code
  // @todo we're also having million classes for each element for so many cases,
  // we can probably merge all functionality they use to single one
  if (header.classList.contains('header--fixed')) {
    if (!body.classList.contains('body--modal-open')) {
      if (window.scrollY > headerScrollThreshold) {
        header.classList.add(headerScrollingClass);
      } else {
        header.classList.remove(headerScrollingClass);
      }
    } else if (window.scrollY !== 0) {
      header.classList.remove(headerScrollingClass);
    }
  }
});
